<template>
    <section class="service-plans" itemscope itemtype="https://schema.org/ItemList">
        <BannerComponent title="Planes de servicio" show="false" paragraph="Elije el que más se acomode a tu necesidad"
            colorTitle="black" colorParagraph="gray" backgroundColor="transparent" urlImg="" urlImgDark=""
            aligmentContent="center" buttonLabel="Click aquí" buttonBackground="#1f8cc6" buttonColor="white"
            buttonLink="" paddingY="80px" marginB="0" />
        <div class="row nunito">
            <div class="plan" :class="p.name" v-for="p of plans" v-bind:key="p.id" itemscope itemtype="https://schema.org/Service">
                <div class="badge" itemprop="name" v-text="p.name"></div>
                <h3 itemprop="name" v-text="'Plan ' + p.name"></h3>
                <hr>
                <p class="">Servicios</p>
                <ul v-for="(s, i) of p.services" v-bind:key="i">
                    <li itemprop="serviceType"><i class="fa-solid fa-circle-check"></i><span v-html="s"></span></li>
                </ul>
                <div class="prices">
                    <span>Precio</span>
                    
                    <p class="price" itemprop="offers" itemscope itemtype="https://schema.org/Offer" >
                        
                        <span itemprop="price" v-text="p.price + '/mes'"></span>
                    </p>
                </div>
                <a :href="`https://wa.me/18298073310?text=Hola%2C%20me%20interesa%20el%20plan%20${p.name}%20de%20${p.price}%20en%20tus%20servicios.`"
                    target="_blank" itemprop="url">Elegir este plan</a>
            </div>
        </div>
    </section>
</template>

<script>
import BannerComponent from '../components/Banner-component.vue';
import plansData from "@/data/plans.json";
export default {
    name: "PlanesPage",
    components: {
        BannerComponent
    },
    data() {
        return {
            plans: plansData
        };
    }
}
</script>
<style scoped>
body.dark-theme .service-plans {
    .row {
        .plan {
            background: rgba(255, 255, 255, 0.836);

            .badge {
                background: #0c1729;
            }

            h3 {}

            hr {}

            p {}

            ul {
                li {}

            }

            a {
                background: #0c1729;
            }
        }
    }
}

.service-plans {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;


    .row {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: self-start;
        flex-wrap: wrap;
        gap: 30px;



        .plan {
            max-width: 300px;
            width: 100%;
            background-color: #fff;
            border: 1px solid #c8c8c8;
            border-radius: 10px;
            padding: 20px;
            margin: 20 px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            position: relative;

            .badge {
                position: absolute;
                top: -20px;
                left: 20px;
                border-radius: 10px;
                background: #0c1729;
                color: #fff;
                padding: 10px 20px;

            }

            h3 {
                height: 50px;
                display: flex;
                text-align: center;
                justify-content: center;
                align-items: center;
                font-weight: 900;
                margin-top: 0;
                color: #000000;
            }

            hr {
                margin: 10px 0;
            }

            p {
                font-size: 1rem;
                font-size: 24px;
                font-weight: 700;
            }

            ul {
                list-style-type: none;
                padding: 0;
                margin: 0 0 20px 0;

                li {
                    display: flex;
                    gap: 10px;
                    align-items: center;
                    width: 100%;
                    text-align: left;
                    margin: 10px 0;

                    i {
                        color: #ce7506;
                    }
                }
            }

            .prices {
                color: #0c1729;

                .price {
                    font-size: 1.5rem;
                    font-weight: bold;
                }
            }

            a {
                padding: 15px;
                width: 100%;
                margin-top: 20px;
                border-radius: 10px;
                text-align: center;
                text-decoration: none;
                display: block;
                background: #0c1729;
                color: #fff;
            }
        }
    }

}
</style>